import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery';


interface GetProfileData {
    pageId: string
}

export const onboardingApi: any = createApi({
    reducerPath: 'onboardingApi',
    baseQuery: axiosBaseQuery(),
    endpoints: (builder) => ({
        getOnboardingData: builder.query<GetProfileData, void>({
            query: (pageId) => ({
                url: `/onboarding`,
                method: 'GET',
                params: { page_id: pageId }
            }),
        }),
        postOnboardingData: builder.mutation<any, Partial<any>>({
            query: (newPost) => ({
                url: '/onboarding',
                method: 'POST',
                data: newPost,
            }),
        }),
    }),
});

export const { useGetOnboardingDataQuery, usePostOnboardingDataMutation } = onboardingApi;
